/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum org_coursera_course_CertificateType {
  ACE = "ACE",
  SoA = "SoA",
  Specialization = "Specialization",
  VerifiedCert = "VerifiedCert",
}

export enum org_coursera_course_CourseStatus {
  draft = "draft",
  inactive = "inactive",
  launched = "launched",
  preenroll = "preenroll",
}

export enum org_coursera_course_PremiumExperienceVariant {
  BaseVariant = "BaseVariant",
  PremiumCourse = "PremiumCourse",
  PremiumGrading = "PremiumGrading",
}

export enum org_coursera_program_membership_ProgramMembershipState {
  DELETED_MEMBER = "DELETED_MEMBER",
  INVITED = "INVITED",
  INVITED_EMAIL_NOT_VERIFIED = "INVITED_EMAIL_NOT_VERIFIED",
  MEMBER = "MEMBER",
  NOT_MEMBER = "NOT_MEMBER",
  SOFT_DELETED_MEMBER = "SOFT_DELETED_MEMBER",
  WHITELISTED = "WHITELISTED",
}

export enum org_coursera_skill_GoalType {
  LITERACY = "LITERACY",
  RESKILL = "RESKILL",
  UPSKILL = "UPSKILL",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
